import styled from 'styled-components'
import { tsToDate } from './utils/tsToDate'
import { useGeneralContext } from './contexts/GeneralContext'
import { Grid } from '@material-ui/core'
import { Redirect, useHistory } from 'react-router-dom'
import { navDirections } from './utils/navDirections'
import { REAL_DB } from '../firebase'
import { useAuthContext } from './contexts/AuthContext'

function ExamInstructions() {
    const { examSelected, createTimeStampInDB } = useGeneralContext()
    const { userDetails } = useAuthContext()
    const history = useHistory()

    async function checkForTime() {
        const dbRef = REAL_DB.ref()

        await createTimeStampInDB()

        await dbRef
            .child('timestamps')
            .child(userDetails?.uid)
            .get()
            .then((snapshot) => {
                if (snapshot.exists()) {
                    const data = snapshot.val()
                    if (
                        data?.timestamp >= examSelected?.timeAtReal &&
                        data?.timestamp <
                            examSelected?.timeAtReal +
                                examSelected?.duration * 60 * 1000
                    ) {
                        history.push(navDirections.EXAMS_PAGE)
                    }
                } else {
                    console.log('No data available')
                }
            })
            .catch((error) => {
                console.error(error)
            })
    }

    return (
        (!!examSelected && (
            <InstructionContainer>
                <Heading>Instructions for Exam</Heading>
                <InstructionCard>
                    <Grid container spacing={1}>
                        <Grid item xs={12}>
                            <p>{examSelected?.title || ''}</p>
                        </Grid>

                        <Grid item xs={3}>
                            <p>{'Subject'}</p>
                        </Grid>
                        <Grid item xs={1}>
                            <p>{`:`}</p>
                        </Grid>
                        <Grid item xs={8}>
                            <p>{examSelected?.subject || ''}</p>
                        </Grid>

                        <Grid item xs={3}>
                            <p>{'Duration'}</p>
                        </Grid>
                        <Grid item xs={1}>
                            <p>{`:`}</p>
                        </Grid>
                        <Grid item xs={8}>
                            <p>{`${examSelected?.duration || ''} minutes`}</p>
                        </Grid>

                        <Grid item xs={3}>
                            <p>{'Starts At'}</p>
                        </Grid>
                        <Grid item xs={1}>
                            <p>{`:`}</p>
                        </Grid>
                        <Grid item xs={8}>
                            <p>
                                {`${tsToDate(examSelected?.time)[1]} ${
                                    tsToDate(examSelected?.time)[2]
                                }`}
                            </p>
                        </Grid>
                    </Grid>

                    {[
                        `Each question carries 4 marks. For each correct response, the candidate will get 4 marks. For each incorrect response, 1 mark will be deducted from the total score.`,
                        `If a question is left blank or, no answer is selected by the candidate, there will be no penalty for that particular question.`,
                        `On completion of the exam, candidate can submit the answer sheet by clicking the End exam button in the drawer, or the answer sheet will be submitted automatically after the scheduled time.`,
                        `The result will be displayed on the new screen which includes Total questions, Attended, Correct Answers, Wrong Answers, Total Marks and Percentage.`
                    ].map((point, index) => (
                        <div key={index}>
                            <br />
                            <Grid container spacing={1}>
                                <Grid item xs={1}>
                                    <p>{`${index + 1}.`}</p>
                                </Grid>
                                <Grid item xs={11}>
                                    <p>{point}</p>
                                </Grid>
                            </Grid>
                        </div>
                    ))}
                </InstructionCard>
                <StartExamButton onClick={checkForTime}>
                    <p>Start</p>
                </StartExamButton>
            </InstructionContainer>
        )) || <Redirect to={navDirections.HOME} />
    )
}

const InstructionContainer = styled.div`
    padding-top: 4.5rem;
    margin-bottom: 70px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    color: #fff;
`

const Heading = styled.h1`
    text-align: center;
    color: #fff;
    padding: 1.2rem 0;
    font-size: 24px;
    z-index: 1;
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    width: 100%;
    background-color: #2e2e53;
`

const InstructionCard = styled.div`
    background: #343660;
    border-radius: 20px;
    width: 100%;
    padding: 20px;
    color: #fff;
    max-width: 500px;
    margin-top: 30px;
    p {
        font-size: 15px;
    }
`
const StartExamButton = styled.button`
    background: linear-gradient(
            131.63deg,
            rgba(41, 43, 92, 0.6) 9.65%,
            rgba(40, 43, 92, 0.58) 93.77%
        ),
        linear-gradient(
            105.27deg,
            rgba(255, 255, 255, 0.105) 2.25%,
            rgba(154, 154, 154, 0.035) 49.02%,
            rgba(201, 201, 201, 0.07) 60.55%,
            rgba(255, 255, 255, 0.042) 68.44%,
            rgba(129, 143, 161, 0.0424448) 84.06%,
            rgba(0, 28, 65, 0) 100%
        );
    box-shadow: 0px 0px 0px -1px rgba(255, 255, 255, 0.1);
    backdrop-filter: blur(22px);
    padding: 15px 20px;
    border-radius: 8px;
    color: #fff;
    outline: none;
    border: none;
    width: 250px;
    margin: 20px auto;
    font-size: 16px;
    cursor: pointer;
`

export default ExamInstructions
